import React, { useState } from 'react';
import {
  DatePicker,
  Select,
  Button,
  InputNumber,
  Form as AntForm,
  Alert,
} from 'antd';
import { Form, Formik } from 'formik';
import openErrorNotification from '../../Utils/openErrorNotification';
import style from './Forms.module.css';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../Api/api';
import Description from '../Description/Description';
import { REQUEST_GET_SELF_CLAIMS } from '../../Redux/constants/constants';

const { RangePicker, MonthPicker } = DatePicker;
const { Option } = Select;

const NewClaim = () => {
  const dispatch = useDispatch();
  const authUserData = useSelector((state) => state.authenticatedUserData);
  const selfData = useSelector((state) => state.selfData);
  const [status, setStatus] = useState('');

  return (
    <Formik
      initialValues={{
        claimType: 'typ wniosku',
        sickLeaveDateRange: [],
        vacationDateRange: [],
        unpaidLeaveDateRange: [],
        overtimeLeaveDateRange: [],
        hours: 0,
        month: undefined,
      }}
      validateOnChange={false}
      validate={(values) => {
        const errors = {};
        if (values.claimType === 'typ wniosku') {
          errors.claimType = 'wymagane';
        }
        if (
          values.claimType === 'sickLeave' &&
          values.sickLeaveDateRange.length === 0
        ) {
          errors.sickLeaveDateRange = 'wymagane';
        }
        if (
          values.claimType === 'vacation' &&
          values.vacationDateRange.length === 0
        ) {
          errors.vacationDateRange = 'wymagane';
        }
        if (
          values.claimType === 'unpaidLeave' &&
          values.unpaidLeaveDateRange.length === 0
        ) {
          errors.unpaidLeaveDateRange = 'wymagane';
        }
        if (
          values.claimType === 'overtimeLeave' &&
          values.overtimeLeaveDateRange.length === 0
        ) {
          errors.overtimeLeaveDateRange = 'wymagane';
        }
        if (values.claimType === 'overtimeToWorkHours' && values.hours === 0) {
          errors.hours = 'wymagane';
        }
        if (
          values.claimType === 'overtimeToWorkHours' &&
          values.month === undefined
        ) {
          errors.month = 'wymagane';
        }
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        api
          .postClaim(values)
          .then(() => {
            setSubmitting(false);
            setStatus('saved');
            dispatch({ type: REQUEST_GET_SELF_CLAIMS });
          })
          .catch((e) => {
            setStatus('error');
            openErrorNotification(e);
          });
      }}
    >
      {({ isSubmitting, values, errors, handleSubmit, setFieldValue }) => (
        <Form className={style.wrapper}>
          <p>{authUserData && authUserData.name}</p>
          <AntForm.Item
            validateStatus={errors.claimType && 'error'}
            help={errors.claimType}
          >
            <Select
              type="claimType"
              name="claimType"
              value={values.claimType}
              defaultValue=""
              onChange={(value) => setFieldValue('claimType', value)}
            >
              <Option value="sickLeave">L4</Option>
              <Option value="vacation">Urlop</Option>
              <Option value="unpaidLeave">Urlop niepłatny</Option>
              <Option value="overtimeLeave">Urlop z nadgodzin</Option>
              <Option value="overtimeToWorkHours">
                Dopełnienie z nadgodzin
              </Option>
            </Select>
          </AntForm.Item>
          {values.claimType === 'sickLeave' && (
            <AntForm.Item
              validateStatus={errors.sickLeaveDateRange && 'error'}
              help={errors.sickLeaveDateRange}
            >
              <RangePicker
                onChange={(value) => setFieldValue('sickLeaveDateRange', value)}
              />
            </AntForm.Item>
          )}
          {values.claimType === 'vacation' && (
            <div>
              <Description
                small
                description={'Dostępna ilość dni wolnych:'}
                value={selfData.leftVacationDays}
              />
              <AntForm.Item
                validateStatus={errors.vacationDateRange && 'error'}
                help={errors.vacationDateRange}
              >
                <RangePicker
                  onChange={(value) =>
                    setFieldValue('vacationDateRange', value)
                  }
                />
              </AntForm.Item>
            </div>
          )}
          {values.claimType === 'unpaidLeave' && (
            <AntForm.Item
              validateStatus={errors.unpaidLeaveDateRange && 'error'}
              help={errors.unpaidLeaveDateRange}
            >
              <RangePicker
                onChange={(value) =>
                  setFieldValue('unpaidLeaveDateRange', value)
                }
              />
            </AntForm.Item>
          )}
          {values.claimType === 'overtimeLeave' && (
            <AntForm.Item
              validateStatus={errors.overtimeLeaveDateRange && 'error'}
              help={errors.overtimeLeaveDateRange}
            >
              <Description
                small
                description={'Dostępna ilość nadgodzin:'}
                value={selfData.availableOvertime}
              />
              <RangePicker
                onChange={(value) =>
                  setFieldValue('overtimeLeaveDateRange', value)
                }
              />
            </AntForm.Item>
          )}
          {values.claimType === 'overtimeToWorkHours' && (
            <div>
              <Description
                small
                description={'Dostępna ilość nadgodzin:'}
                value={selfData.availableOvertime}
              />
              <div className={style.infoInput}>
                <p>Do dopełnienia:</p>
                <AntForm.Item
                  validateStatus={errors.hours && 'error'}
                  help={errors.hours}
                >
                  <InputNumber
                    className={style.inputWidth}
                    min={0}
                    max={selfData.availableOvertime}
                    step={0.5}
                    onChange={(value) => setFieldValue('hours', value)}
                  />
                </AntForm.Item>
              </div>
              <div className={style.infoInput}>
                <p>Dla miesiąca:</p>
                <AntForm.Item
                  validateStatus={errors.month && 'error'}
                  help={errors.month}
                >
                  <MonthPicker
                    className={style.inputWidth}
                    onChange={(value) => setFieldValue('month', value)}
                  />
                </AntForm.Item>
              </div>
            </div>
          )}
          <Button type="submit" disabled={isSubmitting} onClick={handleSubmit}>
            Wyślij
          </Button>
          {status === 'saved' && (
            <Alert message="Wniosek wysłany" type="success" showIcon />
          )}
          {status === 'error' && (
            <Alert message="Błąd zapisu" type="error" showIcon />
          )}
        </Form>
      )}
    </Formik>
  );
};

export default NewClaim;
